// src/components/CardSearch.js
import React, { useState, useEffect } from 'react';
import FilterBar from './FilterBar';
import CardList from './CardList';
import './CardSearch.css';

function CardSearch({ addCardToDeck, deck, showCardDetails, cardTypeOptions, elementOptions, subElementOptions, powerOptions, corpsOptions, levelOptions, sexOptions, plusPowerTargetOptions, plusPowerOptions, chapterOptions }) {
  const [allCards, setAllCards] = useState([]);
  const [queries, setQueries] = useState({ cardId: '', cardName: '', description: '' });
  const [filters, setFilters] = useState({
                                           grif: []
                                          , mogora: []
                                          , cosmo: []
                                          , metro: []
                                          , neos: []
                                          , notMetro: []
                                          , type: []
                                          , element: []
                                          , subElement: []
                                          , power: []
                                          , corps: []
                                          , level: []
                                          , sex: []
                                          , plusPowerTarget: null
                                          , minPlusPower: null
                                          , maxPlusPower: null
                                          , minSpeed: null
                                          , maxSpeed: null
                                          , minAge: null
                                          , maxAge: null
                                          , chapter: []
                                          , hongkong: []
                                        });
  const [filteredCards, setFilteredCards] = useState([]);

  // APIデータ取得用の汎用関数
  const fetchData = async (url, setter, errorMessage) => {
    try {
      const response = await fetch(url);
      const data = await response.json();
      setter(data);
    } catch (error) {
      console.error(errorMessage, error);
    }
  };

  // カードデータを取得
  useEffect(() => {
    fetchData('/api/cards', setAllCards, 'カードデータ取得エラー:');
  }, []);

  // フィルタリング処理
  useEffect(() => {
    if (allCards.length === 0) {
      setFilteredCards([]); // allCards がまだ取得されていない場合は空にする
      return;
    }
  
    // 初期状態ではフィルタを適用せず全カード表示
    const filtered = allCards.filter((card) => {
      const matches = {
        cardId: card.card_id.toLowerCase().includes(queries.cardId.toLowerCase()),
        cardName: card.card_name.includes(queries.cardName),
        description: card.description.includes(queries.description),
        ////////////////////// metroがチェックされていない時はnot_metro_flagが0でも強制表示しない(普通に判定)ようにしたい ////////////////////////
/*         grif: card.not_metro_flag === '0' 
          //? (filters.grif.length > 0 && filters.metro.length > 0 ? filters.grif.includes(card.continent_flag_grif) : true)
          ? true
          : (filters.grif.length > 0 ? filters.grif.includes(card.continent_flag_grif) : true),
        mogora: card.not_metro_flag === '0' 
          ? true  // 🔹 `not_metro_flag` が `0` の場合は無条件で表示
          : (filters.mogora.length > 0 ? filters.mogora.includes(card.continent_flag_mogora) : true),
        cosmo: card.not_metro_flag === '0' 
          ? true  // 🔹 `not_metro_flag` が `0` の場合は無条件で表示
          : (filters.cosmo.length > 0 ? filters.cosmo.includes(card.continent_flag_cosmo) : true),
        metro: filters.metro.length > 0 ? filters.metro.includes(card.continent_flag_metro) : true,
        neos: card.not_metro_flag === '0' 
          ? true  // 🔹 `not_metro_flag` が `0` の場合は無条件で表示
          : (filters.neos.length > 0 ? filters.neos.includes(card.continent_flag_neos) : true), */
        continent: (() => {
          const {
            continent_flag_grif,
            continent_flag_mogora,
            continent_flag_cosmo,
            continent_flag_metro,
            continent_flag_neos,
            not_metro_flag,
          } = card;

          const isNotMetro = String(not_metro_flag) === '1';

          const grifOn = filters.grif.includes('1');
          const mogoraOn = filters.mogora.includes('1');
          const cosmoOn = filters.cosmo.includes('1');
          const metroOn = filters.metro.includes('1');
          const neosOn = filters.neos.includes('1');

          const isGrif = Number(continent_flag_grif) === 1;
          const isMogora = Number(continent_flag_mogora) === 1;
          const isCosmo = Number(continent_flag_cosmo) === 1;
          const isMetro = Number(continent_flag_metro) === 1;
          const isNeos = Number(continent_flag_neos) === 1;

          const noContinentSelected =
            !grifOn && !mogoraOn && !cosmoOn && !metroOn && !neosOn;

          // 🔹 フィルタ未選択なら全部表示
          if (noContinentSelected) return true;

          const ownContinentOn =
            (isGrif && grifOn) ||
            (isMogora && mogoraOn) ||
            (isCosmo && cosmoOn) ||
            (isNeos && neosOn) ||
            (isMetro && metroOn);

          // 🔹 not_metro_flag === 1
          if (isNotMetro) {
            return ownContinentOn;
          }

          // 🔹 not_metro_flag === 0
          // 自分の大陸もOFFかつmetroもOFFなら非表示
          if (!ownContinentOn && !metroOn) {
            return false;
          }

          return true;
        })(),
        type: filters.type.length > 0 ? filters.type.includes(card.card_type_code) : true,
        element: filters.element.length > 0 ? filters.element.includes(card.element_code) : true,
        subElement: filters.subElement.length > 0 ? filters.subElement.includes(card.sub_element_code) : true,
        power: filters.power.length > 0 ? filters.power.includes(card.power_code) : true,
        corps: filters.corps.length > 0 ? filters.corps.includes(card.corps_code) : true,
        level: filters.level.length > 0 ? filters.level.includes(card.level_code) : true,
        sex: filters.sex.length > 0 ? filters.sex.includes(card.sex_code) : true,
        plusPowerTarget: filters.plusPowerTarget
          ? [card.plus_power_target_1, card.plus_power_target_2, card.plus_power_target_3].includes(filters.plusPowerTarget)
          : true,
        minPlusPower: filters.minPlusPower !== null
        ? (
            filters.plusPowerTarget === null
              ? [card.plus_power_1, card.plus_power_2, card.plus_power_3].some((power) => power != null && power >= filters.minPlusPower)
              : (
                  filters.plusPowerTarget === card.plus_power_target_1 ? card.plus_power_1 >= filters.minPlusPower
                : filters.plusPowerTarget === card.plus_power_target_2 ? card.plus_power_2 >= filters.minPlusPower
                : filters.plusPowerTarget === card.plus_power_target_3 ? card.plus_power_3 >= filters.minPlusPower
                : true
              )
          )
        : true,
        maxPlusPower: filters.maxPlusPower !== null
          ? (
              filters.plusPowerTarget === null
                ? [card.plus_power_1, card.plus_power_2, card.plus_power_3].some((power) => power != null && power <= filters.maxPlusPower)
                : (
                    filters.plusPowerTarget === card.plus_power_target_1 ? card.plus_power_1 <= filters.maxPlusPower
                  : filters.plusPowerTarget === card.plus_power_target_2 ? card.plus_power_2 <= filters.maxPlusPower
                  : filters.plusPowerTarget === card.plus_power_target_3 ? card.plus_power_3 <= filters.maxPlusPower
                  : true
                )
            )
          : true,
        // plusPowerTarget が選択されていない場合でも、いずれかの plus_power_* がフィルタ条件を満たすかどうか
        plusPowerForUnselectedTarget: filters.plusPowerTarget === null 
          ? (
              [card.plus_power_1, card.plus_power_2, card.plus_power_3].some((power) => {
                return (
                  (filters.minPlusPower === null || power >= filters.minPlusPower) &&
                  (filters.maxPlusPower === null || power <= filters.maxPlusPower)
                );
              })
            )
          : true,
        minSpeed: filters.minSpeed !== null ? card.speed >= filters.minSpeed : true,
        maxSpeed: filters.maxSpeed !== null ? (card.speed !== null && card.speed <= filters.maxSpeed) : true,
        minAge: filters.minAge !== null ? card.age >= filters.minAge : true,
        maxAge: filters.maxAge !== null ? (card.age !== null && card.age <= filters.maxAge) : true,
        chapter: filters.chapter.length > 0 ? filters.chapter.includes(card.chapter_code) : true,
        hongkong: filters.hongkong.length > 0 ? filters.hongkong.includes(card.hongkong_flag) : true,
      };
        
      return Object.values(matches).every(Boolean);
    });

    setFilteredCards(filtered);
  }, [allCards, filters, queries]);

  // フィルタ変更時の処理
  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
  };

  // クエリ変更時の処理
  const handleQueryChange = (key, value) => {
    setQueries((prev) => ({ ...prev, [key]: value }));
  };

  return (
    <div className="card-search">
      <div className="input-group">
        <label>
          カード番号
          <input
            type="text"
            value={queries.cardId}
            onChange={(e) => handleQueryChange('cardId', e.target.value)}
            placeholder="カード番号を入力"
          />
        </label>
        <label>
          カード名
          <input
            type="text"
            value={queries.cardName}
            onChange={(e) => handleQueryChange('cardName', e.target.value)}
            placeholder="カード名を入力"
          />
        </label>
        <label>
          効果テキスト
          <input
            type="text"
            value={queries.description}
            onChange={(e) => handleQueryChange('description', e.target.value)}
            placeholder="効果テキストを入力"
          />
        </label>
      </div>
      <div className="divider"></div>
      <FilterBar
        onFilterChange={handleFilterChange}
        cardTypeOptions={cardTypeOptions}
        elementOptions={elementOptions}
        subElementOptions={subElementOptions}
        powerOptions={powerOptions}
        corpsOptions={corpsOptions}
        levelOptions={levelOptions}
        sexOptions={sexOptions}
        plusPowerTargetOptions={plusPowerTargetOptions}
        plusPowerOptions={plusPowerOptions}
        chapterOptions={chapterOptions}
      />
      <CardList
        cards={filteredCards}
        addCardToDeck={addCardToDeck}
        deck={deck}
        showCardDetails={showCardDetails}
      />
    </div>
  );
}

export default CardSearch;